import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { FormatMoney } from 'Utils/functions'
import { t } from 'i18next'
import { setPendingAddProductId } from 'redux/actions/cartActions'
import { useDispatch } from 'react-redux'
import addDrillIcon from 'Assets/Images/Generals/addDrillIcon.svg'
import addExtendedWarranty from 'Assets/Images/Generals/addExtendedWarranty.svg'
import ModalAddServiceInstallation from 'Components/ModalAddServiceInstallation'
import ModalAddExtendedWarranty from 'Components/ModalAddExtendedWarranty'
import './TableContent.css'

export const TableContent = ({
  rows,
  addToCart,
  sentinelRef,
  prepareRow,
  showModalProducts,
}) => {
  const dispatch = useDispatch()
  const [installationService, setInstallationService] = useState(null)
  const [productInformation, setProductInformation] = useState(null)
  const [showModalInstallation, setShowModalInstallation] = useState(false)
  const [showModalExtendedWarranty, setShowModalExtendedWarranty] =
    useState(false)

  const handleClickProduct = product => {
    showModalProducts('product', product)
  }

  const handleClickInventary = product => {
    showModalProducts('inventary', product)
  }

  const handleMouseDownAddProduct = product => {
    dispatch(setPendingAddProductId(product.ProductId))
  }

  return (
    <>
      <ModalAddServiceInstallation
        show={showModalInstallation}
        installationService={installationService}
        services={installationService?.relatedServices || []}
        onClose={() => setShowModalInstallation(false)}
      />
      <ModalAddExtendedWarranty
        show={showModalExtendedWarranty}
        productInformation={productInformation}
        onClose={() => setShowModalExtendedWarranty(false)}
      />
      {rows?.map((row, i) => {
        prepareRow(row)
        const productId = row.original?.ProductId || row.original?.codigo || i
        return (
          <tr
            key={i}
            {...row.getRowProps()}
            data-testid={`table-row-product-${productId}`}>
            {row.cells.map(cell => {
              return cell.column.Header === 'Imagen' ? (
                <td
                  onClick={() => {
                    handleClickProduct(cell.row.original)
                  }}
                  key={cell.value}
                  {...cell.getCellProps({
                    style: {
                      maxWidth: '100px',
                      textAlign: 'center',
                    },
                  })}
                  data-testid={`table-cell-image-${productId}`}>
                  <img
                    src={cell.value}
                    alt="product-image"
                    style={{ maxWidth: '42px' }}
                    data-testid={`img-product-${productId}`}
                  />
                </td>
              ) : cell.column.Header === 'Precio' ||
                cell.column.Header === 'Descuento' ? (
                <td
                  {...cell.getCellProps()}
                  data-testid={`table-cell-${cell.column.Header?.toLowerCase()}-${productId}`}>
                  ${cell.value === 0 ? '0.00' : FormatMoney(cell.value)}
                </td>
              ) : cell.column.Header === t('SELL_BY_PROD_T.IN_STORE_HEADER') ? (
                <td
                  {...cell.getCellProps()}
                  onClick={() => {
                    handleClickInventary(cell.row.original)
                  }}
                  data-testid={`table-cell-in-store-${productId}`}>
                  {cell.render('Cell')}
                </td>
              ) : cell.column.Header === 'Acciones' ? (
                <td
                  key={`acciones-${cell.row.index}`}
                  data-testid={`table-cell-actions-${productId}`}>
                  {typeof cell.value === 'object' &&
                  (cell.value.canAdd ||
                    cell.value.canInstall ||
                    cell.value.hasExtendedWarranty) ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '7px',
                      }}
                      data-testid={`container-actions-${productId}`}>
                      {cell.value.canAdd && (
                        <FontAwesomeIcon
                          style={{
                            color: '#003082',
                            fontSize: '2.3rem',
                            cursor: 'pointer',
                          }}
                          icon={faCirclePlus}
                          title={t('ADD_TO_CART')}
                          onMouseDown={() =>
                            handleMouseDownAddProduct(cell.row.original)
                          }
                          onClick={() => {
                            addToCart(cell.row.original)
                            setTimeout(() => {
                              dispatch(setPendingAddProductId(null))
                            }, 50)
                          }}
                          data-testid={`btn-add-to-cart-${productId}`}
                        />
                      )}

                      {cell.value.canInstall && (
                        <button
                          className="addServiceTableContent"
                          onClick={e => {
                            e.preventDefault()
                            setInstallationService({
                              ...cell.value.installationService,
                              productSku: cell.row.original.codigo,
                            })
                            setShowModalInstallation(true)
                          }}
                          data-testid={`btn-add-installation-${productId}`}>
                          <img
                            src={addDrillIcon}
                            alt="installation-icon"
                            title={t(
                              'INSTALLATION_SERVICE_T.ADD_INSTALLATION_SERVICE'
                            )}
                            style={{
                              width: '23px',
                              height: '23px',
                              cursor: 'pointer',
                            }}
                            data-testid={`img-installation-icon-${productId}`}
                          />
                        </button>
                      )}

                      {cell.value.hasExtendedWarranty && (
                        <button
                          className="addServiceTableContent"
                          onClick={e => {
                            e.preventDefault()
                            setProductInformation({
                              ...cell.row.original,
                            })
                            setShowModalExtendedWarranty(true)
                          }}>
                          <img
                            src={addExtendedWarranty}
                            alt="extended-warranty-icon"
                            title={t(
                              'INSTALLATION_SERVICE_T.ADD_INSTALLATION_SERVICE'
                            )}
                            style={{
                              width: '23px',
                              height: '23px',
                              cursor: 'pointer',
                            }}
                          />
                        </button>
                      )}
                    </div>
                  ) : (
                    <p data-testid={`text-no-price-${productId}`}>
                      {t('NO_PRICE')}
                    </p>
                  )}
                </td>
              ) : cell.column.Header === 'Descripción' ||
                cell.column.Header === 'Código' ? (
                <td
                  key={cell.value}
                  onClick={() => {
                    handleClickProduct(cell.row.original)
                  }}
                  {...cell.getCellProps()}
                  data-testid={`table-cell-${cell.column.Header?.toLowerCase()}-${productId}`}>
                  {cell.render('Cell')}
                </td>
              ) : (
                <td
                  key={cell.value}
                  {...cell.getCellProps()}
                  data-testid={`table-cell-${cell.column?.Header}-${productId}`}>
                  {cell.render('Cell')}
                </td>
              )
            })}
          </tr>
        )
      })}
      <tr
        className="ais-InfiniteHits-sentinel"
        ref={sentinelRef}
        aria-hidden="true"
        data-testid="sentinel-infinite-scroll"
      />
    </>
  )
}
